<template>
  <div class="tm-skeleton-details-table-sms-preview">
    <div class="tm-skeleton-details-table-sms-preview__header">
      <tm-skeleton
        type="text"
        height="20px"
        width="50%"
        class="mt-1 mb-2"
      />
      <div class="tm-skeleton-details-table-sms-preview__content">
        <tm-skeleton
          type="text"
          height="12px"
          width="22%"
        />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import TmSkeleton from '@/components/shared/skeletons/TmSkeleton.vue'
</script>

<style lang="scss" scoped>
.tm-skeleton-details-table-sms-preview {
  border-radius: 8px;
  border: 1px solid $gray2;
  min-width: 300px;
  overflow: hidden;

  &__header {
    padding: 16px 20px;
    border-bottom: 1px solid $gray2;
  }

  &__content {
    margin-top: 10px;
    padding: 22px 18px;
    border-radius: $border-radius-lg;
    border: 1px solid #ebeef5;
    background: $shade;
  }
}
</style>
